module.exports = __webpack_public_path__ + "static/media/noiseSlinky.26020421.mp4";